import { connect } from 'react-redux';
import StaffSpaces from './StaffSpaces';
import { currentUserId } from '../../../../../../core/selectors/user';

const mapStateToProps = (state) => ({
  userId: currentUserId(state),
});

export default connect(mapStateToProps)(StaffSpaces);
